import { apiClient } from "./ApiClient";

export type ReportSheetEntry = Record<string, string | number | boolean> & {
  ChangedColumn: string;
  File1Value: string | number | boolean;
  File2Value: string | number | boolean;
};

export type ReportComparisonSummary = Record<string, ReportSheetEntry[]>;

export class ReportComparatorService {
  static async compareReports(
    file1: File,
    file2: File,
  ): Promise<ReportComparisonSummary> {
    const formData = new FormData();
    formData.append("file1", file1, file1.name);
    formData.append("file2", file2, file2.name);

    const response = await apiClient.post("/report-comparator/compare", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data["final summary"] ?? {};
  }
}
